export class ReturnStruct{
    public isError:boolean;
    public errorCode:number;
    public errorDescription:string;
}